import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/base';
import {
  GridFilterOperator,
  GridQuery,
  gridQueryToRequestQuery,
  GridRespose,
  NotificationListItem,
  NotificationSave,
  NotificationStatus
} from '@shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminNotificationsApiService extends BaseApiService {
  constructor(private http: HttpClient) {
    super();
  }

  public getList(params: GridQuery): Observable<GridRespose<NotificationListItem>> {
    const reqParams = gridQueryToRequestQuery(params);
    if (params.searchText) {
      reqParams.filters.push({
        columnNames: ['title'],
        operator: GridFilterOperator.Contains,
        values: [params.searchText]
      });
    }

    return this.http.post<GridRespose<NotificationListItem>>(
      `${this.queryBaseUrl}/admin/notifications/query`,
      reqParams
    );
  }

  public create(data: NotificationSave): Observable<unknown> {
    return this.http.post(`${this.commandBaseUrl}/admin/notifications`, data);
  }

  public delete(id: string): Observable<unknown> {
    return this.http.delete(`${this.commandBaseUrl}/admin/notifications/${id}`);
  }

  public updateStatus(id: string, status: NotificationStatus): Observable<unknown> {
    return this.http.put(`${this.commandBaseUrl}/admin/notifications/${id}/status`, { status });
  }

  public updateEndDate(id: string, endDate: Date): Observable<unknown> {
    return this.http.put(`${this.commandBaseUrl}/admin/notifications/${id}/endDate`, { endDate });
  }

  public update(id: string, data: NotificationSave): Observable<unknown> {
    return this.http.put(`${this.commandBaseUrl}/admin/notifications/${id}`, data);
  }
}
